import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import ImpersonationBanner from '../ImpersonationBanner';
import Toast from '../ui/Toast';

const DashboardLayout = () => {
  const { user, loading } = useAuth();
  // Start expanded on desktop, collapsed on mobile. The Topbar button toggles it on both.
  const [sidebarOpen, setSidebarOpen] = useState(
    () => typeof window !== 'undefined' && window.innerWidth >= 1024
  );

  if (loading) return null;
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <ImpersonationBanner />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onNavigate={() => { if (window.innerWidth < 1024) setSidebarOpen(false); }}
        />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Topbar onMenuClick={() => setSidebarOpen((v) => !v)} />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-slate-50 p-4 sm:p-8">
            <Outlet />
          </main>
        </div>
      </div>
      <Toast />
    </div>
  );
};

export default DashboardLayout;
